import React from 'react';
import PropTypes from 'prop-types';
import classes from './ImportProduct.module.scss';

const ImportProductStep1 = (props) => {
  const {
    title,
    processing,
    csvfile,
    handleChange,
    processCSV,
    renderButton,
  } = props;

  return (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <div className={classes.title}>{title}</div>
        <label htmlFor='file' className={classes.label}>
          Please, select your file:
          <input
            id='file'
            className={classes.input}
            type='file'
            disabled={processing}
            name='file'
            placeholder={null}
            onChange={handleChange}
            accept='.csv, text/csv'
            aria-label='Upload File'
          />
        </label>
        {renderButton('ButtonA', 'Process', processCSV, !csvfile)}
      </div>
    </div>
  );
};

ImportProductStep1.propTypes = {
  title: PropTypes.string,
  processing: PropTypes.bool,
  csvfile: PropTypes.object,
  handleChange: PropTypes.func,
  processCSV: PropTypes.func,
  renderButton: PropTypes.func,
};

export default ImportProductStep1;
